module.exports = __webpack_public_path__ + "img/Mstorybg5.d138f46e.jpg";